import { Box, Tooltip, Typography, useTheme } from "@mui/material";
import type { AttackerSpend } from "@/types";

// Below this, a precise SEK figure is noise — surface a qualitative "Low"
// instead of an awkward "~0 kr".
const LOW_SPEND_THRESHOLD_SEK = 20;

function formatSpend(n: number): string {
  if (n < LOW_SPEND_THRESHOLD_SEK) return "Low";
  return `~${Math.round(n).toLocaleString("sv-SE")} kr`;
}

export default function AttackerSpendTile({
  data,
  onClick,
}: {
  readonly data: AttackerSpend;
  readonly onClick: () => void;
}) {
  const theme = useTheme();
  return (
    <Tooltip
      title="Infrastructure cost your attackers paid to send this traffic."
      arrow
    >
      <Box
        onClick={onClick}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onClick();
          }
        }}
        role="button"
        tabIndex={0}
        sx={{ cursor: "pointer" }}
      >
        <Typography variant="overline" sx={{ color: theme.palette.text.secondary, fontSize: "0.625rem", letterSpacing: "0.08em" }}>
          Estimated attacker spend
        </Typography>
        <Typography variant="h4" sx={{ fontWeight: 700, letterSpacing: "-0.02em", fontSize: "1.75rem" }}>
          {formatSpend(data.central_sek)}
        </Typography>
        <Typography variant="caption" sx={{ color: theme.palette.text.secondary, display: "block", mt: 0.25 }}>
          0 logins succeeded
        </Typography>
      </Box>
    </Tooltip>
  );
}
